/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.service('IntentService', ["$rootScope", "$http", function ($rootScope, $http) {

        var myIntent = {}
        var intentKey = "intents"
        var started = false;
        var events = {}
        
        var _startIntent = function ()
        {
            var item = localStorage.getItem(intentKey)
            localStorage.removeItem(intentKey);
            if(item == null)
            {
                item = "{}"
            }
            myIntent = JSON.parse(item)
        }

        var registerModel = function(name,model)
        {
            
            events[name] = model;
        }
        
        var getModel = function(name)
        {
            
            return events[name]
        }
        
        
        
        var setIntent = function (item)
        {
            if (!started)
            {
                _startIntent()
            }
            stringItem = JSON.stringify(item)
            localStorage.setItem(intentKey, stringItem)
        }

        var getIntent = function ()
        {
            if (!started)
            {
                _startIntent()
            }
            return myIntent
        }

        return {
            setIntent: setIntent,
            getIntent: getIntent,
            registerModel:registerModel,
            getModel:getModel
        };

    }]);